import { render, staticRenderFns } from "./MultiLangTextarea.vue?vue&type=template&id=644f1adc&"
import script from "./MultiLangTextarea.vue?vue&type=script&lang=js&"
export * from "./MultiLangTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports